import { SET_NUMBER_OF_DAYS } from '../actions/types';

export default function numberOfDays(state = 0, action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_NUMBER_OF_DAYS: {
				return action.payload;
			}
			// no default
		}
	}

	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/numberOfDays.js